import { useAtomValue } from "jotai"
import { relativeTimeNowAtom } from "~/atoms/relative-time-now"

const rtf = new Intl.RelativeTimeFormat("ru", { numeric: "always", style: "short" })

const DIVISIONS = [
    { amount: 60, name: "seconds" },
    { amount: 60, name: "minutes" },
    { amount: 24, name: "hours" },
    { amount: 7, name: "days" },
    { amount: 4.34524, name: "weeks" },
    { amount: 12, name: "months" },
    { amount: Number.POSITIVE_INFINITY, name: "years" },
] as const

function formatRelativeTime(date: Date, nowMs: number): string {
    let duration = (date.getTime() - nowMs) / 1000

    if (duration >= 0) return "только что"

    const roundedSeconds = Math.round(duration)
    if (Math.abs(roundedSeconds) <= 60) {
        return rtf.format(roundedSeconds, "seconds")
    }

    duration /= 60

    for (const division of DIVISIONS.slice(1)) {
        const roundedDuration = Math.round(duration)
        if (Math.abs(roundedDuration) < division.amount) {
            return rtf.format(roundedDuration, division.name)
        }
        duration /= division.amount
    }
    return rtf.format(Math.round(duration), "years")
}

interface RelativeTimeProps {
    date: Date | string
    className?: string
}

export function RelativeTime({ date, className }: RelativeTimeProps) {
    const nowMs = useAtomValue(relativeTimeNowAtom)
    const d = typeof date === "string" ? new Date(date) : date
    return (
        <time dateTime={d.toISOString()} className={className}>
            {formatRelativeTime(d, nowMs)}
        </time>
    )
}
